<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">短信管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="发送人" prop="Sender">
            <el-input v-model="Sender" placeholder="请输入发送人"></el-input>
          </el-form-item>
          <el-form-item label="发送时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
              unlink-panels
            ></el-date-picker>
          </el-form-item>

          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="dialogVisible = true"
            >发送短信</el-button
          >
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="Creater" label="发送人"></el-table-column>
              <el-table-column prop="Extends2" label="接受人"></el-table-column>
              <el-table-column
                prop="SendTime"
                label="发送时间"
                :formatter="formatDate"
                width="200"
              ></el-table-column>
              <el-table-column prop="SendStatus" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.SendStatus == '0'">未发送</span>
                  <span v-else-if="scope.row.SendStatus == '1'">已发送</span>
                  <span v-else-if="scope.row.SendStatus == '2'">发送失败</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <el-dialog
        v-dialogDrag
        custom-class="customClass"
        title="短信发送"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleDialogClose"
      >
        <div class="smsTree">
          <el-container>
            <el-aside>
              <div class="treeContent">
                <el-tree
                  @node-click="nodeClick"
                  :data="nodes"
                  node-key="Id"
                  :props="defaultProps"
                  :filter-node-method="filterNode"
                  ref="tree"
                  show-checkbox
                  v-loading="loadingTree"
                  element-loading-text="加载中..."
                  :default-expand-all="true"
                ></el-tree>
              </div>
            </el-aside>
            <el-container style="padding-left: 10px">
              <el-input
                type="textarea"
                :autosize="{ minRows: 8 }"
                v-model="content"
              ></el-input>
            </el-container>
          </el-container>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="sendSms()">发 送</el-button>
        </span>
      </el-dialog>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import utils from "../../../../../../utils";
// import waitAll from "../../../../../../utils/src/waitAll";
export default {
  name: "SmsList",
  controller: "UI",
  action: "SmsList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      Sender: "",
      date: [],
      dialogVisible: false,
      loading: false,
      loadingText: "加载中...",
      loadingTree: false,
      filterText: "",
      defaultProps: {
        children: "children",
        label: "Name",
      },
      content: "",
    };
  },
  created: function () {
    //当前设定的日期时间
    let d = new Date();
    let year1, month1, day1;
    [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
    let date1 = new Date(year1, month1, day1, 7);
    this.date.push(date1);
    //前一天设定的日期时间
    let year2, month2, day2;
    d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
    [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
    let date2 = new Date(year2, month2, day2, 7);
    this.date.unshift(date2);
    //  this.getAdminInfo();
    this.loadSmsData();
  },
  mounted: function () {
    this.search();
    // this.init();
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    //短信接收人组织架构接口
    loadSmsData() {
      this.loadingTree = true;
      utils
        .waitAll([
          () => {
            //获取不带权限的组织信息
            return new Apis.UserApi().FindByConditions({ LoginName: "admin" });
          },
          (r) => {
            let user = r[0].data.Data;
            if (user != null && user.length > 0) {
              const userId = user[0].UserId;
              return utils.waitAll([
                () => {
                  return new Apis.OrgUserApi().FindUserCompany({
                    UserId: userId,
                  });
                },
                (r) => {
                  //获取组织下的用户信息
                  let arr = [];
                  let api = new Apis.OrgUserApi();
                  let orgs = r[0].data.Data || [];
                  for (let i = 0; i < orgs.length; i++) {
                    arr.push(
                      api.GetUsersByOrgId({
                        OrgId: orgs[i].OrgId,
                      })
                    );
                  }
                  return utils.waitAll(arr);
                },
              ]);
            }
          },
        ])
        .then((r) => {
          let orgInfo = r[1][0].data.Data || [];
          console.log("orgInfo");
          console.log(orgInfo);
          const orgs = orgInfo.map((item) => {
            return {
              Id: item.OrgId,
              Name: item.OrgName,
              ParentId: item.ParentOrgId,
              PhoneNo: "",
            };
          });

          let userArr = [];
          let userData = r[1][1] || [];
          for (let i = 0; i < userData.length; i++) {
            userArr = userArr.concat(userData[i].data.Data);
          }

          //过滤重复用户
          const res = new Map();
          const userNew = userArr.filter(
            (item) => !res.has(item.UserId) && res.set(item.UserId, 1)
          );
          const users = userNew.map((item) => {
            return {
              Id: item.UserId,
              Name: item.UserName,
              ParentId: item.OrgId,
              PhoneNo: item.Phone,
            };
          });
         
          const orgUsers = orgs.concat(users);
          this.convertToTreeNodes(orgUsers);
          this.loadingTree = false;
        })
        .catch((e) => {
          this.loadingTree = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    convertToTreeNodes(dataList) {
      let formatObj = dataList.reduce((pre, cur) => {
        return { ...pre, [cur["Id"]]: cur };
      }, {});

      let formatArray = dataList.reduce((arr, cur) => {
        let pid = cur.ParentId ? cur.ParentId : 0;
        let parent = formatObj[pid];
        if (parent) {
          parent.children
            ? parent.children.push(cur)
            : (parent.children = [cur]);
        } else {
          arr.push(cur);
        }
        return arr;
      }, []);
     
      this.nodes = formatArray;
      // this.convertToTreeNodesfunction(formatArray);
    },

    sendSms() {
      if (this.content == null || this.content == "") {
        this.$message({
          type: "warning",
          message: "请输入短信内容",
        });
        return;
      }

      const selectedSmsTreeNode = this.$refs.tree.getCheckedNodes();
      const receivers = selectedSmsTreeNode.filter((item) => {
        return item.PhoneNo != "" && item.PhoneNo != null;
      });
      const PhoneNo = receivers.map((item) => item.PhoneNo).join(";");
      const receiver = receivers.map((item) => item.Name).join(";");
  
      // 清空树中选择的数据
      this.$refs.tree.setCheckedKeys([]);
      const count = receivers.length;
      //var arr = [];
      if (count > 0) {
        console.log(new Date());
        this.loading = true;
        this.loadingText = "发送中...";
        new MyApis.TranResourcesApi()
          .SendSms({
            // Id: 1,
            Id: ZJApp.ZJUtils.uuid(),
            PhoneNo: PhoneNo,
            Content: this.content,
            Charset: "GBK",
            Creater: ZJApp.ZJUser.current.UserName,
            CreateTime: new Date(),
            Modifier: ZJApp.ZJUser.current.UserName,
            ModifyTime: new Date(),
            SendTime: new Date(),
            Extends2: receiver,
          })
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "发送成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
            this.$message(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择短信接受人",
        });
        return;
      }
    },
    search() {
      let searchInfo = {
        Creater: this.Sender,
        BeginDate: this.date == null ? "0001-01-01T00:00:00" : this.date[0],
        EndDate:
          this.date == null
            ? "0001-01-01T00:00:00"
            : new Date((this.date[1] / 1000 + 86400) * 1000),
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //查看
    queryDetail(index, row) {
      console.log(row);
      this.$router.push({
        path: "/plugin/sms/ui/SmsDetail",
        query: { InfoId: row.Id },
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.Sender = "";
      this.date = [];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style lang="scss">
.smsTree {
  height: 300px;
  .el-tree {
    min-width: 100%;
    display: inline-block;
  }
  .treeContent {
    overflow: auto;
    max-height: 300px;
  }
}
.customClass {
  .el-dialog__footer {
    text-align: center !important;
  }
}
</style>